@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../constants/spacing.module.less';
@import '../../../../constants/screen-width-breakpoints.module.less';

.cards {
  gap: @space-24;
  flex: 1;
  min-width: 0;
  max-width: 912px;
}

.card-feed {
  align-items: center;
  gap: @space-24;
  padding-bottom: @space-24;
}

.active-cards {
  flex-direction: column-reverse;
}

.cards-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: @space-24;
  gap: @space-16;
}

.toggle-visible-button {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.visibility-icon {
  width: 24px;
  height: 24px;
}

.cards-container {
  gap: @space-24;
}

.empty-state-container {
  align-items: center;
  gap: @space-16;
  width: 736px;
  padding: @space-36 @space-24;
  border-radius: 4px;
  background: var(--grey-000);
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.05);
}

.empty-state-image {
  width: 214px;
  height: 214px;
}

.card {
  background-color: var(--white);
  border-radius: 8px;
  padding: @space-24 @space-0 @space-0;
  border: 1px solid var(--grey-300);
  width: 100%;
  max-width: 912px;
  min-height: 258px;
}

.card-header {
  justify-content: space-between;
}

.card-title {
  align-items: center;
}

.body {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: @space-0 @space-24 @space-24;
  overflow: hidden;
}

.tag {
  display: flex;
  align-items: center;
  padding: @space-0 @space-8;
  margin-left: @space-8;
  color: var(--grey-600);
  font-weight: 500;
  border-radius: 16px;
  border: 1px solid var(--grey-600);
  background: var(--grey-100);
}

.length {
  align-items: center;
  gap: @space-8;
  color: var(--grey-600);
  flex-wrap: unset;
}

.clock-icon {
  width: 16px;
  height: 16px;
}

.image {
  max-width: 290px;
  max-height: 156px;
}

// WISTIA

.wistia_responsive_padding {
  padding: 56.25% 0 0;
}

.wistia_responsive_wrapper {
  height: 151px;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.wistia_embed {
  height: 151px;
  width: 100%;
}

.wistia_swatch {
  width: 292px;
  left: 0;
  opacity: 1;
}

.wistia_img {
  filter: blur(5px);
  height: 151px;
  width: 292px;
  object-fit: contain;
}

.action-button {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: @space-8;
}

.body-text {
  gap: @space-4;
}

.card-text {
  background-color: @onboarding-page--container--background-color;
  padding: @space-0 @space-24 @space-16 @space-0;
  text-align: left;
  height: auto;
  min-width: 200px;
}

.list-items {
  margin-left: @space-24;

  .list-item {
    display: list-item;
    list-style-type: disc;
  }
}

.circle-play-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
}

.title {
  justify-content: space-between;
  font-size: 20px;
  font-weight: @semi-bold;
  line-height: 20px;
  padding: @space-0 @space-24 @space-0 @space-24;
  margin: @space-0 @space-0 @space-16;
}

.card-buttons {
  display: flex;
  align-items: center;
  gap: @space-16;
}

.link-and-icon {
  gap: @space-8;
}

.read-article {
  font-size: 16px;
  font-weight: 500;
}

.external-link-icon {
  width: 14px;
  height: 14px;
  color: var(--primary--link--text-color--2);
}

.filter-pills {
  gap: @space-8;
}

.filter-pill {
  display: flex;
  padding: @space-0 @space-8;
  align-items: center;
  gap: @space-8;
  border-radius: 34px;
  border: 1px solid var(--grey-500);
  background: var(--grey-200);
  box-shadow: 0 1px 1px 0 rgba(33, 44, 54, 0.35);
  color: var(--grey-800);
}

.pill-text {
  font-size: 12px;
}

.selected-filter {
  color: var(--Neutral-000, #fff);
  border: 1px solid var(--grey-500);
  background: var(--grey-500);
}

.inline-icon {
  width: 12px;
  height: 12px;
}

.custom-body {
  padding: @space-0 @space-24 @space-16 @space-24;
  line-height: 24px;
}

.filter-buttons-container {
  gap: @space-12;
}

.loading-indicator {
  width: 100px;
  height: 100px;
  margin: auto;
}

.loading-text {
  text-align: center;
  padding-bottom: @space-48;
}
